export class ApplicationConfig {
  version: string;
  googleMapsApiKey: string;
  authMode: string;
  azureTenantId: string;
  azureClientId: string;
  azureRedirectUrl: string;
  azureLogoutUrl: string;
  features: string[];
  homeScreen: string;
  termsAndConditions: string;
  welcome: string;
  agreement: string;
  latestReleaseNotesId: number;
}


